/**
 * Lazy loader
 *
 * This component requires jQuery to function.
 * You can require it on the page using <div data-component="lazy-loader"></div>
 */

const $window = $(window);

$('[data-component="lazy-loader"]').each(function () {
    const $holder = $(this);

    let ajax_in_progress = false;

    $window.scroll(() => {
        const top = $window.scrollTop();
        const window_height = $window.height();

        const $loader = $('.loader', $holder);
        const $next = $('.loader .next', $holder);

        if (!ajax_in_progress && $next.length > 0) {
            if ((top + window_height) >= ($holder.offset().top + $holder.height())) {
                $loader.show();
                ajax_in_progress = true;

                $.ajax(
                    {
                        url: $next.attr('href'),
                        success(response) {
                            const $response = $(response);
                            $loader.remove();
                            $holder.append($('[data-component="lazy-loader"]', $response).html());
                            ajax_in_progress = false;
                        },
                        error() {
                            window.location.href = $next.attr('href');
                        },
                    },
                );
            }
        }
    });
});
